import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tag_active",
  "use": "tag_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"tag_active\"><path fill-rule=\"evenodd\" d=\"M2.003 4h10.995c.553 0 1.285.34 1.645.772l3.714 4.456c.355.426.36 1.112 0 1.544l-3.714 4.456c-.355.426-1.099.772-1.645.772H2.003A1.004 1.004 0 0 1 1 15.003V4.997C1 4.447 1.438 4 2.003 4ZM4 8h1v4H4V8Zm2 0h1v4H6V8Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol